import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, getGustToken } from '@/utils/auth'
import { getTemporaryToken } from '@/api/login'
import route from '../router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
        config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    if (store.getters.gustToken) {
      config.headers['Authorization'] = 'Guest ' + getGustToken()
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res && res.type === 'application/octet-stream') {
        return res
    }
    if(res.code === 0) {
        return res
    }
    // 根据特殊的code进行处理
    // 4000: 公园资源建设中，敬请期待
    if (res.code === 4000) {
        // 跳转到导览页
        route.push({path: '/'})
        return res;
    }
    Message({
      message: res.message,
      type: 'error',
      duration: 3 * 1000
    })
    // return Promise.reject(res.message || '系统错误')
  },
  error => {
    console.log('err' + error)
    if (error.response && error.response.data) {
      const { code, message } = error.response.data;
      const { status, statusText } = error.response;
      // token 过期,重新登录
      // TODO  游客token过期话，主动刷新token
      if(code === 402){
        if (!localStorage.getItem('gustAccessToken')) {
          return false
        }
        localStorage.removeItem('gustAccessToken')
        window.location.reload()
      } else if (code === 401 || status === 401) { // token失效，下载无token
        // to re-login
        console.log('登录信息已失效，请重新登录')
        store.dispatch('user/resetToken').then(() => {
          //跳转到登录页面
          route.push({
            name: 'Login',
            query: {
              type: 'login'
            }
          })
        })
        // MessageBox.confirm('登录信息已失效，请重新登录', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        // })
      } else  {
        Message({
          message: message || '系统异常，请稍后重试!',
          type: 'error',
          duration: 3 * 1000
        })
      }
    }
    return error
  }
)

export default service
